export default function SuccessIcon() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="50" height="50" rx="25" fill="#E6F2E3" />
      <rect x="5" y="5" width="40" height="40" rx="20" fill="#6DC067" />
      <path
        d="M17 24L23 30L34 19"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
